
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item :to="item.path" v-for="(item, index) in breadcrumbList" :key="index">{{ item.name
      }}</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.lecturer_name" placeholder="输入讲师名称"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      </el-form-item>
      <el-form-item v-if="userinfo.Permissions_type != 3">
        <el-button size="small" type="primary" icon="el-icon-plus" @click="add()">添加</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中"
      style="width: 100%;">
      <el-table-column align="center" type="selection" width="40">
      </el-table-column>
      <el-table-column prop="lid" label="ID" width="40">
      </el-table-column>
      <el-table-column prop="lecturer_name" label="讲师名称" width="100" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="trainer_name" label="上级代理" width="80" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="face" label="讲师头像" width="80" show-overflow-tooltip>
        <template slot-scope="scope">
          <div class="demo-image__preview">
            <el-image style="height: 24px;" v-if="scope.row.face" class="table_list_pic" :src="scope.row.face"
              :preview-src-list="[scope.row.face]"></el-image>
            <div v-else>暂无图片</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="introduce" label="讲师介绍" width="160" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="phone" label="手机号/账号" width="100" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="dy_number" label="抖音号" width="100" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="ks_number" label="快手号" width="100" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="status" label="讲师状态" width="80">
        <template slot-scope="{row}">
          <div v-if="row.status == 0">正常</div>
          <div v-else>锁定</div>
        </template>
      </el-table-column>
      <el-table-column prop="is_ok'" label="审核状态" width="140">
        <template slot-scope="{row}">
          <div v-if="row.is_ok == 0">0未提交审核</div>
          <div v-else-if="row.is_ok == 1">1资质已提交审核中</div>
          <div v-else-if="row.is_ok == 2">2资质审核通过</div>
          <div v-else-if="row.is_ok == 3">3资质审核不通过</div>
          <div v-else-if="row.is_ok == 4">4授权小程序中</div>
          <div v-else-if="row.is_ok == 5">5授权小程序通过</div>
          <div v-else>授权小程序不通过</div>
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="审核提示" width="100" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="create_time" label="创建时间" width="100" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" label="操作" min-width="380" height="200">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="update(scope.row)"><i class="el-icon-edit" />修改</el-button>
          <el-button size="mini" type="primary" @click="Update1(scope.row)"><i class="el-icon-edit" />修改密码</el-button>
          <!-- <el-button size="mini" v-if="userinfo.Permissions_type == 3" type="success" @click="addimg(scope.row)"><i
              class="el-icon-plus" />上传资质</el-button> -->
          <el-button size="mini" v-if="userinfo.Permissions_type != 3" type="danger" @click="del(scope.row)"><i
              class="el-icon-delete" />删除</el-button>
          <el-dropdown trigger="click" style="margin-left: 10px;">
          <el-button size="mini" type="info">更多操作</el-button>
            <el-dropdown-menu slot="dropdown">
              <el-button size="mini" type="success" @click="addimg(scope.row)"><i class="el-icon-plus" />上传资质</el-button>
              <el-button size="mini" v-if="userinfo.Permissions_type == 1" type="success" @click="shenh(scope.row)"><i class="el-icon-edit-outline" />提交审核</el-button>
              <el-button size="mini" type="success" @click="detail(scope.row)"><i class="el-icon-view" />审核状态</el-button>
              <el-button size="mini" type="success" @click="xiaochex(scope.row)"><i class="el-icon-edit-outline" />授权小程序</el-button>
              <el-button size="mini" type="success" @click="details(scope.row)"><i class="el-icon-view" />小程序状态</el-button>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <Add :show.sync="dialog.addDialogStatus" @refesh_list="getdata"></Add>
    <Update :info="updateInfo" :show.sync="dialog.updateDialogStatus" size="small" @refesh_list="getdata"></Update>
    <Updatepws :lid="lid" :show.sync="dialog.updatepwss" size="small" @refesh_list="getdata"></Updatepws>
    <Updateimg :lids="lids" :info="updateInfoimg" :show.sync="dialog.imgDialogStatus" @refesh_list="getdata"></Updateimg>
  </div>
</template>
  
<script>
import { getLecturer, getdelete, getLectureredit, getBypartner, getStatus, getUpResources,getRole,getRoleStatus } from '../../api/userMG'
import Pagination from '../../components/Pagination'
import Update from './update.vue'
import Add from './add.vue'
import Updatepws from './updatepws.vue'
import Updateimg from './updateimg.vue'
export default {
  // 注册组件
  components: {
    Pagination, Add, Update, Updatepws, Updateimg
  },
  data() {
    return {
      state: [
        { key: '请选择', value: '' },
        { key: '未支付', value: 0 },
        { key: '已支付', value: 1 },
      ],
      type: [
        { key: '请选择', value: '' },
        { key: '微信', value: 0 },
        { key: '抖音', value: 1 },
        { key: '快手', value: 2 }
      ],
      dialog: {
        addDialogStatus: false,
        updateDialogStatus: false,
        updatepwss: false,
        imgDialogStatus: false
      },
      btnstype: '0',
      buttonlist: [
        { key: '请选择', value: '' },
        { key: '微信', value: 0 },
        { key: '抖音', value: 1 },
        { key: '快手', value: 2 }
      ],
      breadcrumbList: [],
      updateInfo: {},
      updateInfoimg: {},
      loading: false, //是显示加载
      formInline: {
        lecturer_name: '',
        page: 1
      },
      listData: [],
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      userinfo: {},
      lid: 0,
      lids:0
    }
  },
  created() {
    this.getdata()
    this.generateBreadcrumb()
    this.userinfo = JSON.parse(localStorage.getItem('userdata'))
    console.log(this.userinfo.Permissions_type, '=-0------');
  },
  watch: {
    $route() {
      this.generateBreadcrumb()
    }
  },
  methods: {
    addimg(row) {
      getUpResources({ lid: row.lid, echo: 'get' }).then(res => {
        if (res.code == 200) {
          this.dialog.imgDialogStatus = true
            this.updateInfoimg = res.info
            this.lids = row.lid * 1


          // if( res.info == null){
          //   this.lids = row.lid * 1
          // }else{
          //   this.updateInfoimg = res.info
          // }
        }
      })
    },
    add() {
      this.dialog.addDialogStatus = true
    },
    search() {
      this.formInline.page = 1
      this.getdata(this.formInline)
    },
    Update1(row) {
      console.log(row);
      this.lid = row.lid * 1
      this.dialog.updatepwss = true
    },
    update(row) {
      console.log(row);
      getLectureredit({ lid: row.lid, echo: 'get' }).then(res => {
        console.log(res);
        if (res.code == 200) {
          this.dialog.updateDialogStatus = true
          this.updateInfo = res.info
        }
      })
    },
    shenh(row) {
      this.$confirm('确定要提交审核吗?', '提交审核', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning '
      }).then(() => {
        getBypartner({ lid: row.lid }).then(res => {
          if (res.code == 200) {
            this.$message({ message: '提交成功', type: 'success' })
            this.getdata()
          } else {
            this.$message({ message: '提交失败', type: 'error' })
          }
        })
      })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消审核'
          })
        })
    },
    xiaochex(row) {
      this.$confirm('确定要授权小程序吗?', '授权小程序', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning '
      }).then(() => {
        getRole({ lid: row.lid }).then(res => {
          if (res.code == 200) {
            this.$message({ message: '提交成功', type: 'success' })
            this.getdata()
          } else {
            this.$message({ message: res.msg, type: 'error' })
          }
        })
      })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消审核'
          })
        })
    },
    details(row) {
      getRoleStatus({ lid: row.lid }).then(res => {
        console.log(res.msg);
        this.$confirm(res.msg, '讲师资质审核状态', {
          confirmButtonText: '确定',
        })
      })
    },
    detail(row) {
      getStatus({ lid: row.lid }).then(res => {
        console.log(res.msg);
        this.$confirm(res.msg, '讲师资质审核状态', {
          confirmButtonText: '确定',
        })
      })
    },
    del(row) {
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        getdelete({ lid: row.lid }).then(res => {
          if (res.code == 200) {
            this.$message({ message: '删除成功', type: 'success' })
            this.getdata()
          } else {
            this.$message({ message: '删除失败', type: 'error' })
          }
        })
      })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    generateBreadcrumb() {
      // 获取当前路由信息
      const matched = this.$route.matched
      console.log(matched, '++++++++++');
      // 初始化面包屑导航数据
      const breadcrumbList = []
      // 遍历路由信息，生成面包屑导航数据
      matched.forEach(item => {
        const { meta, name, path } = item
        if (meta.requireAuth) {
          breadcrumbList.push({
            name,
            path
          })
        }
      })
      // 保存面包屑导航数据
      this.breadcrumbList = breadcrumbList
    },
    getdata() {
      this.loading = true
      getLecturer(this.formInline).then(res => {
        console.log(res);
        if (res.code == 200) {
          this.listData = res.info.data
          this.pageparm.total = res.info.total
          this.loading = false

        }
      })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getdata(this.formInline)
    },
  }
}
</script>
  
<style scoped>
.user-search {
  margin-top: 20px;
}

.userRole {
  width: 100%;
}
</style>
  
   
   


// WEBPACK FOOTER //
// src/views/lecturer/index.vue